import React, { useEffect, useState } from 'react'
import { RouteComponentProps, useLocation } from 'react-router-dom'
import Header from './Header'
import StoryItem from './StoryItem'
import Submenu from './Submenu'
import Loader from './Loader'

interface Props extends RouteComponentProps<{ id: string }> {}

const SingleStoryPage: React.FC<Props> = ({ match }) => {
	const [category, setCategory] = useState(match.params.id)
	const [storiesIdArr, setStoriesIdArr] = useState([])
	const [storiesToShow, setStoriesToShow] = useState([])
	const [isLoading, setIsLoading] = useState(true)
	const [page, setPage] = useState(1)

	// detects url change, sets category, fetches IDs
	const location = useLocation()
	useEffect(() => {
		setCategory(match.params.id)
		setIsLoading(true)
		setStoriesIdArr([])
		setPage(1)
	}, [location])

	useEffect(() => {
		fetch(
			`https://hacker-news.firebaseio.com/v0/${category}stories.json?print=pretty`
		)
			.then((res) => res.json())
			.then((res) => {
				setStoriesIdArr(res)
				setIsLoading(false)
			})
			.catch((error) => console.log(error))
	}, [category])

	useEffect(() => {
		if (storiesIdArr.length > 0) {
			setStoriesToShow(storiesIdArr.slice(0, page * 20))
		}
	}, [storiesIdArr, page])

	return (
		<div>
			<Header color={'#4169e0'} />
			<Submenu />

			<div className="single-story-page w-max-center">
				{isLoading ? (
					<Loader />
				) : (
					storiesToShow.map((id) => {
						return <StoryItem id={id} key={id} />
					})
				)}
				<button
					onClick={() => {
						setPage(page + 1)
					}}
					className="loadmore-btn h-small w-full text-salmon underline">
					Load More
				</button>
			</div>
		</div>
	)
}

export default SingleStoryPage
